module.exports = __webpack_public_path__ + "static/media/org_sample_excel.2218bcc8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/org_sample_excel.JPG
// module id = 1435
// module chunks = 1